import HumanTradingDecisionCollectionApp from './HumanTradingDecisionCollectionApp'

function App() {
  return <HumanTradingDecisionCollectionApp />
}

export default App
